class BlSAb extends HTMLElement {  
  constructor() {
    super();
    this.props = {}    
  }
  attributeChangedCallback(name, oldValue, newValue) {   
    setTimeout(()=>{
      this.props[name] = newValue;
      //console.log(name,oldValue,newValue)
      switch (name) {        
        case 'place_on_top':    
          if(newValue==='true'){   
                this.querySelector(".bl_sab_wrapper").style.position = `absolute`;                  
                this.querySelector(".bl_sab_wrapper").style.left = `50`;          
                this.querySelector(".bl_sab_wrapper").style.transform = `'translateX(-50%)'`;          
                this.querySelector(".bl_sab_wrapper").style.width = `'100vw'`;          
          }
        break;
        default:
          //nothing
      }
      if(this.props['is_enabled'])
        this.generateContent();                    
    },1)    
  }

  static get observedAttributes() {
    return [
      'text_color',
      'marquee_text',
      'font_size',
      'font_family',
      'animation_direction_right',
      'animation_enabled',
      'animation_speed',
      'place_on_top',
      'marquee_text_gap',
      'pause_on_hover',
      'is_enabled'
      ];
  }


  generateContent(){
    // this.innerHTML=``;
    
    this.shadowRoot.innerHTML = `
        <div class="bl_sab_wrapper">
            <div class="wrapper ${this.props.animation_enabled === 'true' ? 'enable-animation ' : '' } ${this.props.pause_on_hover === 'true' ? 'hover-pause ' : '' }">
                <ul class="marquee marquee1">        
                ${this.props.marquee_text ? this.props.marquee_text?.repeat(10) : ''}
                </ul>
                <ul aria-hidden="true" class="marquee marquee2">      
                ${this.props.marquee_text ? this.props.marquee_text?.repeat(10) : ''}
                </ul>
            </div>
        </div>
        <div class="bl_sab_heigt_placeholder"></div>
  
  <style>
    div.bl_sab_wrapper{
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      display: flex;
      color: ${this.props.text_color};        
      height: 45px;        
      font-family: ${this.props.font_family};
      font-weight: 400;
      font-style: normal;    
      font-size: ${this.props.font_size}px;
      align-items: center;
    }
    div.bl_sab_wrapper a{
      color: ${this.props.text_color};
      text-decoration: underline;
    }
    .bl_sab_wrapper .wrapper {
      position: relative;
      width: 100%;
    }
    .bl_sab_wrapper .marquee {
      align-items: center;
      width: 100%;
      display: flex;      
      min-width: 100%;
      width: max-content;      
    }
    .bl_sab_wrapper:hover .hover-pause .marquee {
      animation-play-state: paused;
    }
    .bl_sab_wrapper .enable-animation .marquee1 {
      animation: marquee 100s linear infinite;        
      ${this.props.animation_direction_right === 'true' ? 'animation-direction: reverse;' : ''}
      animation-duration: ${this.props.animation_speed}s;
      
    }

    .bl_sab_wrapper .enable-animation .marquee2 {    
      animation: marquee2 100s linear infinite;    
      ${this.props.animation_direction_right === 'true' ? 'animation-direction: reverse;' : ''}
      animation-duration: ${this.props.animation_speed}s;
    }
    .bl_sab_wrapper .marquee2 {        
      position: absolute;
      top: 0;        
    }
    .bl_sab_wrapper ul {
      display: flex;
      list-style: none;
      padding-left: 0;
   }
   .bl_sab_wrapper li {
      display: flex;
      align-items: center;
      margin-left: ${this.props.marquee_text_gap/2}px;
      margin-right: ${this.props.marquee_text_gap/2}px;    
  }
  .bl_sab_wrapper li img {    
    margin-right: 5px;
  }
  @keyframes marquee {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }

  @keyframes marquee2 {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
  </style>
  `;  

  }
  connectedCallback() {
    
    // const wixconfig = JSON.parse(this?.attributes?.wixconfig?.value ?? '{}');
    //   const wixsettings= JSON.parse(this?.attributes?.wixsettings?.value ?? '{}');

    //   // current instanceId
    //   const instanceId = wixconfig?.instanceId || '';
    //   alert(JSON.stringify(wixconfig))
    
    this.attachShadow({mode: 'open'});
    this.generateContent();
  }
}

customElements.define('bl-sab', BlSAb);
// CustomElementRegistry.define('mpa-maab', HelloWorld);